import React, { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import { motion } from "framer-motion";
import {
    Box,
    Container,
    TextField,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography,
    Grid,
    IconButton,
    Card,
    CardContent,
    CardHeader,
    Button,
} from "@mui/material";
import { Plus, Pencil } from "lucide-react";
import BreadCrumbs from "../components/Breadcrumbs";
import {indexPlugins} from "../http/PluginAPI";
import {createStoreCategory, getShopStore, editStoreCategory} from "../http/ShopAPI";
import {getPlugins, installPlugin} from "../http/ServerAPI";

const ServerShopCategories = observer(({ serverId }) => {
    const [open, setOpen] = useState(false);
    const [editing, setEditing] = useState(null);
    const [name, setName] = useState("");
    const [shopStore, setShopStore] = useState({});
    const [loadingShopStore, setLoadingShopStore] = useState(true);

    const handleOpen = (category = null) => {
        setEditing(category);
        setName(category?.name || "");
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setEditing(null);
        setName("");
    };

    const handleSave = async () => {
        if (editing) {
            try {
                await editStoreCategory(editing.id, name);
                getShopStore()
                    .then(setShopStore)
                    .finally(() => setLoadingShopStore(false));
            } catch (e) {
                console.error(e);
            }
        } else {
            try {
                await createStoreCategory(name);
                getShopStore()
                    .then(setShopStore)
                    .finally(() => setLoadingShopStore(false));
            } catch (e) {
                console.error(e);
            }
        }
        handleClose();
    };

    useEffect(() => {
        setLoadingShopStore(true);
        getShopStore()
            .then(setShopStore)
            .finally(() => setLoadingShopStore(false));
    }, [serverId]);

    return (
        <Container maxWidth="xl" sx={{ mt: 4 }}>
            <Box sx={{ width: '100%', marginTop: 3 }}>
                <BreadCrumbs hrefs='' name='Список категорий магазина' />
            </Box>
            <Box sx={{ width: '100%', marginTop: 3 }}>
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
                    <Typography variant="h5" fontWeight={600}>Категории товаров</Typography>
                    <Button onClick={() => handleOpen()}><Plus className="w-4 h-4 mr-1" /> Добавить</Button>
                </Box>

                <Grid container spacing={2}>
                    {shopStore.categories && shopStore.categories.map((cat) => (
                        <Grid item xs={12} sm={6} md={4} key={cat.id}>
                            <motion.div
                                initial={{ opacity: 0, y: 10 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.3 }}
                            >
                                <Card className="relative group">
                                    <CardHeader
                                        title={cat.name}
                                        action={
                                            <IconButton onClick={() => handleOpen(cat)}>
                                                <Pencil className="w-4 h-4" />
                                            </IconButton>
                                        }
                                    />
                                    <CardContent>
                                        <Typography variant="body2">ID: {cat.id}</Typography>
                                    </CardContent>
                                </Card>
                            </motion.div>
                        </Grid>
                    ))}
                </Grid>

                <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
                    <DialogTitle>{editing ? "Редактировать категорию" : "Создать категорию"}</DialogTitle>
                    <DialogContent>
                        <TextField
                            fullWidth
                            label="Название категории"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            margin="normal"
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button variant="ghost" onClick={handleClose}>Отмена</Button>
                        <Button onClick={handleSave}>
                            {editing ? "Сохранить" : "Создать"}
                        </Button>
                    </DialogActions>
                </Dialog>
            </Box>
        </Container>
    );
});

export default ServerShopCategories;
